import { AccountBalanceV2, AccountId, AccountOfferingBalances, ApiResponse } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getAccountBalance = async (accountId?: AccountId) => {
  if (!accountId) {
    return {} as AccountBalanceV2;
  }

  const response = await api.get<ApiResponse<AccountBalanceV2>>(`/accounts/${accountId}/balance`);

  return unwrapApiResponse(response.data);
};

export const getAccountOfferingBalances = async (accountId?: AccountId) => {
  if (!accountId) {
    return {} as AccountOfferingBalances;
  }

  const response = await api.get<ApiResponse<AccountOfferingBalances>>(`/accounts/${accountId}/balance/offerings`);

  return unwrapApiResponse(response.data);
};
